export const SEARCH_HISTORY_VALUE = 'searchHistory';
